import LabelLang from "component/LabelLang/label-lang";
import { DateFormater } from "functions/dateTimeFormat";
import ReactPlayer from "react-player";

export default function Notpinned({
  url,
  title,
  publishingDate,
  videoLibraryTranslations,
}) {
  return (
    <div className="col-12 col-md-6">
      <div className="ved-item1">
        {/* <iframe
          width="100%"
          height="250"
          src={url ? url : "https://www.youtube.com/embed/9WLuF3vjj_U"}
          title="YouTube video player"
          frameBorder={"0"}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        ></iframe> */}
        <ReactPlayer
          url={url ? url : "https://www.youtube.com/embed/9WLuF3vjj_U"}
          width={"100%"}
          height={"250px"}
        />
        <h6>
          <LabelLang
            id="title"
            defaultValue={title}
            translations={videoLibraryTranslations}
          />
        </h6>
        <span>
          {" "}
          <DateFormater value={publishingDate} />
        </span>
      </div>
    </div>
  );
}
